export default __webpack_public_path__ + "static/media/nomina_seguridad.4b5256f6.png";